export class PractitionerSpecializations {
  id: number;
  practitionerId: number;
  specializationCategoryId: number;
}
